import { Directive, ElementRef, HostListener, Injector, OnInit } from '@angular/core';
import { NgControl, FormControlName } from '@angular/forms';

@Directive({
    selector: 'input[decimalOnly]',
    providers: [],
    standalone: false
})


// HACK: 現在exchange-rateのみで使用しており、レート更新のコンポーネントに移行したい
/**
 * 入力内容を制御
 * 整数3桁、小数点第2位までの数値のみ入力を許可し、左記に反する内容は入力不可とする
*/
export class DecimalOnlyControlDirective implements OnInit {
  private beforeValue: string;
  constructor(private el: ElementRef, private injector: Injector) {
  }

  @HostListener('input', ['$event'])
  onInputed() {
    const fcn = this.injector.get(NgControl, null) as FormControlName;
    const target = this.el.nativeElement as HTMLInputElement;
    const value = target.value;

    // 整数3桁小数第2まで許可する正規表現
    const pattern = /^[1-9][0-9]{0,2}(\.[0-9]{0,2})?$/;
    if (pattern.test(value)) {
      fcn.control.setValue(value);
      this.beforeValue = value;
      return;
    }

    // これ以降は入力値が違反のケース。原則前回の入力値をセットする。
    // 入力値が空文字の場合は現在と前回の値を空文字に置き換える
    if (value === '') {
      this.beforeValue = '';
    }
    fcn.control.setValue(this.beforeValue);
  }

  ngOnInit() {
    const target = this.el.nativeElement as HTMLInputElement;
    this.beforeValue = target.value;
  }
}
